module.exports = "<p>trainings works!</p>\r\n"